import { useQuery } from '@tanstack/react-query';
import { BackgroundProcessStatus } from 'src/secret-menu/background-processes/types';

type CalendarSweepStatus = {
  awaitingSweep: number;
  excludedWithoutEmailAddress: number;
  excludedWithoutLiveSuccessor: number;
  // The same condition the trigger endpoints refuse on, so the panel can disable a button rather
  // than let an operator earn a 409.
  runInProgress: boolean;
  lastRunAt: string | null;
  lastRunStatus: BackgroundProcessStatus | null;
  lastRunSwept: number | null;
  lastRunWasDryRun: boolean | null;
};

export const CALENDAR_ORPHAN_SWEEP_PROCESS_NAME = 'CALENDAR_ORPHAN_SWEEP';

export const useCalendarSweepStatus = (companyId: string) => {
  const { data, isError, error, refetch, isRefetching } = useQuery<CalendarSweepStatus>({
    queryKey: ['admin', 'companies', companyId, 'calendar-sweep', 'status'],
  });

  return { status: data, isError, error, refetch, isRefetching };
};
